document.addEventListener('DOMContentLoaded', function () {

  // PRODUCT LIMIT (PAGINATION)
  let productLimit = 30;
  let sortBy = '';
  let currentPageParams = '';

  function removeProductLimitAndSortBy(queryString) {
    // Ensure the first character is not ? or &
    queryString = queryString.replace(/^[?&]/, '');
    return queryString
      .split('&')
      .filter(param => !param.startsWith('productLimit=') && !param.startsWith('sortBy='))
      .join('&');
  }

  document.querySelector('#items_toggle__options').addEventListener('change', function () {
    var selectedValue = this.value;
    productLimit = this.value;
    Shopify.queryParams.productLimit = selectedValue;
    updateContent(currentPageParams);
  });

  // SORT BY
  Shopify.queryParams = {};

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');
    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');
      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }

  document.querySelectorAll('.sort-by__select').forEach((select) => {
    select.addEventListener('change', function (e) {
      sortBy = e.target.value;
      // Shopify.queryParams.sort_by = sortBy;
      updateContent(currentPageParams);
    });
  });

  function updateContent(passedParams, rerenderFilters) {
    const url = new URL(window.location.href);

    console.log(passedParams)

    if (!passedParams) {
      const searchParams = new URLSearchParams(Shopify.queryParams);
      url.search = searchParams.toString().replace(/%2B/g, '+').replace('+++', '+%2B+');
      // console.log('url.searching', url.search);

    } else {
      url.search = passedParams;
    }

    // Remove productLimit from URL
    const cleanQuery = removeProductLimitAndSortBy(url.search);
    // console.log('cleanQuery', cleanQuery);

    // Update the browser's URL to match fetchUrl
    const collectionHandle = document.querySelector('#items_toggle__options').getAttribute('data-collection-handle');
    const fetchUrl = `${window.Shopify.routes.root}collections/${collectionHandle}?view=grid&sort_by=${sortBy}&productLimit=${productLimit}&${cleanQuery}`;
    window.history.pushState({}, '', fetchUrl);

    // Fetch new content based on the updated parameters
    const collectionGrid = document.querySelector('.collection-grid');
    const pagination = document.querySelector('.pagination-container');
    currentPageParams = url.search;

    console.log(currentPageParams);

    fetch(fetchUrl)
      .then(response => response.text())
      .then((text) => {
        const html = document.createElement('div');
        console.log(html);
        html.innerHTML = text;
        const newContent = html.querySelector('.collection-grid');
        const newPagination = html.querySelector('.pagination-container');
        if (rerenderFilters && newContent && newContent.innerHTML.trim().length) {
          let collectionFilters = document.querySelector('.collection-filter');
          let filterContent = html.querySelector('.collection-filter');
          collectionFilters.innerHTML = filterContent.innerHTML;
        }
        if (newContent && newContent.innerHTML.trim().length) {
          collectionGrid.innerHTML = newContent.innerHTML;
          pagination.innerHTML = newPagination.innerHTML;
        } else {
          console.error('No new content found in fetched HTML.');
        }
      })
      .catch(error => {
        console.error('Error fetching new collection grid content:', error);
      });
  }

  // FILTER FORM
  let applyBtn = document.querySelector('.filters-apply-btn input');
  let filterOptions = document.querySelectorAll('.collection-filter .filter-option');

  let filterParams = {};

  // Initialize filterParams with existing URL parameters
  let currentParams = new URLSearchParams(window.location.search);
  for (let [key, value] of currentParams.entries()) {
    if (key.startsWith('filter.p.')) {
      if (!filterParams[key]) {
        filterParams[key] = [];
      }
      filterParams[key].push(value);
    }
  }

  filterOptions.forEach((option) => {
    option.addEventListener('change', () => {
      let paramName = option.name;
      let paramValue = option.value;

      if (!filterParams[paramName]) {
        filterParams[paramName] = [];
      }

      if (option.checked) {
        if (!filterParams[paramName].includes(paramValue)) {
          filterParams[paramName].push(paramValue);
        }
      } else {
        filterParams[paramName] = filterParams[paramName].filter(value => value !== paramValue);
        if (filterParams[paramName].length === 0) {
          delete filterParams[paramName];
        }
      }
    });
  });

  document.body.addEventListener('click', (event) => {
    if (event.target.matches('#applyBtn')) { // Ensure the event is triggered by the apply button
      event.preventDefault();

      let queryString = Object.keys(filterParams)
        .map(key => filterParams[key].map(value => `${key}=${encodeURIComponent(value)}`).join('&'))
        .join('&');

      // Add existing Shopify query params to the filter query string
      let searchParams = new URLSearchParams(queryString);
      for (let key in Shopify.queryParams) {
        searchParams.set(key, Shopify.queryParams[key]);
      }

      // Convert URLSearchParams to string and replace '%2B' with '+'
      let finalQueryString = searchParams.toString().replace(/%2B/g, '+');

      history.replaceState(null, '', '?' + finalQueryString);
      updateContent(finalQueryString, true);
    }
  });


  // Assuming 'document' is the parent element, you can replace it with a more specific parent if needed
  document.addEventListener('click', (event) => {
    // Check if the clicked element is a 'Clear' button
    if (event.target.matches('.section-clear')) {
      event.preventDefault();

      // Find the parent section of the clicked 'Clear' button
      let section = event.target.closest('details');

      // Get all checkboxes in this section
      let checkboxes = section.querySelectorAll('input[type="checkbox"]');

      // Get the parameter name for this section
      let paramName = checkboxes[0].name;

      // Uncheck all checkboxes in this section
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });

      // Remove the entire parameter from filterParams
      delete filterParams[paramName];

      // Create a new URLSearchParams object
      let searchParams = new URLSearchParams();

      // Add remaining filter parameters
      for (let key in filterParams) {
        filterParams[key].forEach(value => {
          searchParams.append(key, value);
        });
      }

      // Add other Shopify query params
      for (let key in Shopify.queryParams) {
        if (key !== paramName) {
          searchParams.set(key, Shopify.queryParams[key]);
        }
      }

      // Convert URLSearchParams to string and replace '%2B' with '+'
      let finalQueryString = searchParams.toString().replace(/%2B/g, '+');
      Shopify.queryParams = searchParams;

      console.log('Shopify: ', Shopify.queryParams);
      updateContent(finalQueryString, true);
    }
  });


});
